import React from 'react';

function PaperClip(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 2C15.3751 2 18.1253 4.67517 18.2459 8.02087L18.25 8.25V15.1242C18.25 15.4693 17.9702 15.7492 17.625 15.7492C17.3112 15.7492 17.0514 15.5179 17.0068 15.2165L17 15.1242V8.25C17 5.48851 14.7615 3.25 12 3.25C9.31118 3.25 7.11818 5.37225 7.00462 8.03311L7 8.25V17.625C7 19.3507 8.39934 20.75 10.125 20.75C11.7911 20.75 13.1531 19.4455 13.2451 17.8023L13.25 17.625V8.25C13.25 7.55934 12.6907 7 12 7C11.3525 7 10.8204 7.49161 10.7565 8.12215L10.75 8.25V16.375C10.75 16.7202 10.4702 17 10.125 17C9.8112 17 9.55142 16.7687 9.50678 16.4674L9.5 16.375V8.25C9.5 6.86899 10.619 5.75 12 5.75C13.3258 5.75 14.4101 6.78126 14.4947 8.08559L14.5 8.25V17.625C14.5 20.041 12.541 22 10.125 22C7.78005 22 5.86563 20.1546 5.75505 17.837L5.75 17.625V8.25C5.75 4.79816 8.54816 2 12 2Z" />
    </svg>
  );
}

export default PaperClip;
